import React, { useState, useEffect } from 'react';

import LoadingSpinner from '../../partials/LoadingSpinner';

const SuggestionItemsModal = ({ payload, showSuggestionItemsModal, setShowSuggestionItemsModal, suggestedPurchaseOrder }) => {
  const update = () => {
    setShowSuggestionItemsModal(false);
  }

  const tableRow = (lineItem) => {
    return (
      <div className="flex-table__row">
        <div className="flex-table__col flex-table__col--align-left">{lineItem?.item_name}</div>
        <div className="flex-table__col flex-table__col--align-left">{lineItem?.supplier_sku}</div>
        <div className="flex-table__col flex-table__col--align-left">{parseInt(lineItem?.stock_quantity) || 0}</div>
        <div className="flex-table__col flex-table__col--align-left">{parseInt(lineItem?.on_order_quantity) || 0}</div>
        <div className={`flex-table__col flex-table__col--align-left ${lineItem?.is_critical ? 'error' : 'warning' }`}>{parseInt(lineItem?.recommended_quantity)}</div>
      </div>
    ) 
  }

  return(
    <div className="main-overlay">
      <div className="main-popup main-popup-top-only main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => update()}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            <h3 className="main-popup__title">
              <span className="gwt-InlineHTML">Purchase Order Items</span>
            </h3>
            <div className="main-popup__text" aria-hidden="true" style={{display: 'none'}}></div>
            <div className="main-popup__content">
              <h4>Suggested Purchase Order Items</h4>

              { suggestedPurchaseOrder && suggestedPurchaseOrder?.suggested_purchase_order_lines &&
                <div className="flex-table">
                  <div className="flex-table__head">
                    <div className="flex-table__col flex-table__col--align-left">Name</div>
                    <div className="flex-table__col flex-table__col--align-left">Suppl. SKU</div>
                    <div className="flex-table__col flex-table__col--align-left">On Hand</div>
                    <div className="flex-table__col flex-table__col--align-left">On Order</div>
                    <div className="flex-table__col flex-table__col--align-left">Rec. Qty</div>
                  </div>
                  { suggestedPurchaseOrder.suggested_purchase_order_lines.suggested_purchase_order_lines.map(lineItem => 
                    tableRow(lineItem)
                  )}

                </div>
              }

              { !suggestedPurchaseOrder &&
                <LoadingSpinner statusText="Loading suggested purchase order" />
              }
            </div>
            <div className="main-popup__buttons">
              <button type="button" className="btn btn-primary btn-medium" tabindex="1000" onClick={() => update()}>
                Close
              </button>
            </div>
            <div className="main-popup__footer-text" aria-hidden="true" style={{display: 'none'}}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuggestionItemsModal;
